import { ReactNode } from 'react';

import Box from "@mui/material/Box";

import { APIProvider } from '@vis.gl/react-google-maps';

import { GOOGLE_PLACES_API_KEY } from "../utils/GoogleMapsUtils";
import { useOnlineStatus } from '../utils/useOnlineStatus';

import { useData } from './DataProvider';

interface MapsProviderProps {
  children: ReactNode;
}

export function MapsProvider({ children }: MapsProviderProps) {
  const { isOnline } = useOnlineStatus();
  const { userState } = useData();

  if (!isOnline || userState.status === 'logged_out') {
    return (
      <Box>
        {children}
      </Box>
    );
  } else {
    return (
      <APIProvider
        apiKey={GOOGLE_PLACES_API_KEY}>
        {children}
      </APIProvider>
    );
  }
}